import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

const LINE_WRAPPER_BASE_SPACING = 10

export const LineActions = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  right: -15px;
  align-items: flex-start;
  justify-content: center;
  transform: translateY(-50%);
  cursor: pointer;
  user-select: none;
`

export const LineWrapper = styled.li`
  margin-top: ${LINE_WRAPPER_BASE_SPACING}px;
  margin-bottom: ${LINE_WRAPPER_BASE_SPACING}px;
  padding-bottom: ${LINE_WRAPPER_BASE_SPACING}px;
  position: relative;
  border-bottom: 1px solid ${Color.Grey150};
  list-style: none;

  &:first-of-type {
    margin-top: ${LINE_WRAPPER_BASE_SPACING * 4}px;
  }
  &:last-of-type {
    padding-bottom: 0;
    border-bottom: 0;
  }
`
